import React, { useState, useEffect, useMemo } from 'react';
import MailMenuIconRender from '../MailMenuIconRender/MailMenuIconRender';
import { mergeMenuConfig } from '../util';
import { MAIL_MENU_ITEM } from '../../../constant';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
const IconMenuKeys = [
    MAIL_MENU_ITEM.RE_EDIT,
    MAIL_MENU_ITEM.REPLAY,
    MAIL_MENU_ITEM.REPLAY_ALL,
    MAIL_MENU_ITEM.FORWARD,
    MAIL_MENU_ITEM.RED_FLAG,
    MAIL_MENU_ITEM.TAG,
    MAIL_MENU_ITEM.DELETE,
];
const IconMenuKeyMap = {};
IconMenuKeys.forEach((item, index) => {
    IconMenuKeyMap[item] = index;
});
const MailMenuIcon = props => {
    const { mail, menu, defaultMenu, menuType, menuItemStateMap, onMenuItemStateChange, beforeMenuItemClick, theme, domProps } = props;
    const [iconMenuData, setIconMenuData] = useState([]);
    useEffect(() => {
        const defaultData = defaultMenu;
        let localData = defaultData;
        if (menu && menu.length) {
            localData = mergeMenuConfig(menu, defaultData);
        }
        setIconMenuData(localData);
    }, [menu, defaultMenu]);
    const beforeMenuClickRef = useCreateCallbackForEvent(beforeMenuItemClick);
    const Element = useMemo(() => {
        return mail ? (React.createElement(MailMenuIconRender, { theme: theme, beforeMenuClick: beforeMenuClickRef, menuItemStateMap: menuItemStateMap, onMenuItemStateChange: onMenuItemStateChange, data: iconMenuData, mailData: mail, menuType: menuType, domProps: domProps })) : (React.createElement(React.Fragment, null));
    }, [iconMenuData, mail, menuItemStateMap, onMenuItemStateChange, theme, domProps]);
    return Element;
};
export default MailMenuIcon;
